import '../../../styles/knowledge-concept/LearningMap.css';
import '../../../styles/knowledge-concept/TopicCard.css';
import '../../../styles/knowledge-concept/SubTopicCard.css';

import { Alert, Box, Button, IconButton, InputBase, Paper } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { addNotebook, setNotebook, setNotebookList } from '../../../store/notebookSlice';
import {
	fetchLearningMapDetails,
	fetchNoteBookList,
	fetchTopicSubtopicNames,
} from '../../../services/DashboardApi.js';
import { setSelectedSubTopicData, setTopicList } from '../../../store/selectedSubTopicSlice.js';
import { useDispatch, useSelector } from 'react-redux';

import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Label from '../../atoms/Label.js';
import Loader from '../../atoms/Loader.jsx';
import SearchIcon from '@mui/icons-material/Search';
import SubTopicCard from '../knowledge-concept/SubTopicCard.jsx';
import TopicCard from './TopicCard.jsx';
import { getUserKcCardData } from '../../../services/MyPathService.js';
import { logger } from '../../../utils/logger';
import { setMainTab } from '../../../store/mainTabSlice.js';

const LearningMap = ({
	handleSubTopicClick,
	setSidebarState,
	handleSubTopicClickInternal,
	fetchAndSetNoteBookList,
}) => {
	// Add search state
	const dispatch = useDispatch();
	const [searchQuery, setSearchQuery] = useState('');
	const [subtopicWidth, setSubtopicWidth] = useState(null);
	const [topics, setTopics] = useState([]);
	const { userId } = useSelector((state) => state.userDetails);
	//logger.log("selectedMainTab:", selectedMainTab)

	const selectedMainTab = useSelector((state) => state.mainTab.tab_name);
	const [isLoading, setIsLoading] = useState(true);
	const [alert, setAlert] = useState({ status: false });
	const [cardSubtopics, setCardSubtopics] = useState({
		READING_WRITING: [],
		MATHS: [],
	});
	const [currentPage, setCurrentPage] = useState(0);
	const scrollRefs = useRef({});
	const subtopicRef = useRef(null);
	const alertTimeoutRef = useRef(null);

	const selectedSubTopicDetails = useSelector(
		(state) => state.selectedSubTopic.selectedSubTopicData
	);

	useEffect(() => {
		const fetchData = async () => {
			setIsLoading(true);
			logger.log('userId inside useEffect of LearningMap: ', userId);
			//let userId = "1049";
			logger.log('selectedMainTab inside useEffect of LearningMap: ', selectedMainTab);
			let subject = selectedMainTab; // Use selectedMainTab as the subject
			try {
				const response = await fetchLearningMapDetails(userId, subject);
				logger.log('Response from API: ', response.data);
				setTopics(response.data);
				dispatch(setTopicList(response.data));
				//logger.log("Topics from API: ", response.data);
			} catch (error) {
				logger.log('Error fetching topics: ', error);
			} finally {
				setIsLoading(false);
			}
		};

		const fetchMyPathData = async () => {
			const response = await getUserKcCardData(userId);
			let { READING_WRITING, MATHS } = response?.data;
			READING_WRITING = READING_WRITING?.filter(
				(card) => card?.saved && card?.subtopicId && card?.subtopicName
			)?.map((card) => card.subtopicId);
			MATHS = MATHS?.filter(
				(card) => card?.saved && card?.subtopicId && card?.subtopicName
			)?.map((card) => card.subtopicId);
			setCardSubtopics({ READING_WRITING: READING_WRITING, MATHS: MATHS });
		};

		fetchData();
		fetchMyPathData();
	}, [selectedMainTab]); // Add selectedMainTab as a dependency

	// Add search filter function
	//logger.log("Topics: ", topics);
	/*const filteredTopics = topics?.filter((topic) => {
    const topicMatch = topic.TOPIC_NAME.toLowerCase().includes(
      searchQuery.toLowerCase()
    );
    const subtopicMatch = topic.SUBTOPICS?.some((subtopic) =>
      subtopic.SUBTOPIC_NAME.toLowerCase().includes(searchQuery.toLowerCase())
    );
    return topicMatch || subtopicMatch;
  });*/
	const filteredTopics = topics
		?.filter((topic) => {
			const topicMatch = topic.TOPIC_NAME.toLowerCase().includes(searchQuery.toLowerCase());

			const subtopicMatch = topic.SUBTOPICS?.some((subtopic) =>
				subtopic.SUBTOPIC_NAME.toLowerCase().includes(searchQuery.toLowerCase())
			);

			return topicMatch || subtopicMatch;
		})
		.map((topic) => {
			const topicMatch = topic.TOPIC_NAME.toLowerCase().includes(searchQuery.toLowerCase());

			// If topic matches, return full topic with all subtopics
			if (topicMatch) {
				return topic;
			}

			// If only subtopics matched, return topic with filtered subtopics
			const filteredSubtopics = topic.SUBTOPICS?.filter((subtopic) =>
				subtopic.SUBTOPIC_NAME.toLowerCase().includes(searchQuery.toLowerCase())
			);

			return {
				...topic,
				SUBTOPICS: filteredSubtopics,
			};
		});

	logger.log('Filtered Topics: ', filteredTopics);
	// Update pagination to use filtered topics
	// const paginatedTopics = filteredTopics?.map((topic) => {
	//   return {
	//     ...topic,
	//     displayedSubtopics: topic.SUBTOPICS?.filter((subtopic) =>
	//       subtopic.SUBTOPIC_NAME.toLowerCase().includes(searchQuery.toLowerCase())
	//     ),
	//   };
	// });
	const paginatedTopics = filteredTopics?.map((topic) => {
		const topicMatch = topic.TOPIC_NAME.toLowerCase().includes(searchQuery.toLowerCase());

		return {
			...topic,
			displayedSubtopics: topicMatch
				? topic.SUBTOPICS // show all subtopics if topic matches
				: topic.SUBTOPICS?.filter((subtopic) =>
						subtopic.SUBTOPIC_NAME.toLowerCase().includes(searchQuery.toLowerCase())
				  ), // show only matching subtopics otherwise
		};
	});

	logger.log('Paginated Topics: ', paginatedTopics);

	const scrollHorizontally = (index, offset) => {
		if (scrollRefs.current[index]) {
			scrollRefs.current[index].scrollBy({
				left: offset,
				behavior: 'smooth',
			});
		}
	};

	useEffect(() => {
		const updateWidth = () => {
			if (subtopicRef.current) {
				const leftOffset = subtopicRef.current.getBoundingClientRect().left; // Distance from left viewport edge
				let availableWidth = ((window.innerWidth - leftOffset) / 16).toFixed(2); // Remaining width
				availableWidth -= 3.81;

				logger.log('Left Offset:', leftOffset);
				logger.log('Available Width:', availableWidth);
				setSubtopicWidth(availableWidth); // Update width state
			}
		};

		// Delay the first calculation to ensure layout is ready
		const timeout = setTimeout(updateWidth, 100);

		window.addEventListener('resize', updateWidth); // Update on resize
		return () => {
			clearTimeout(timeout);
			window.removeEventListener('resize', updateWidth);
		};
	}, [topics]);

	// Determine if pagination is needed for any topic
	// const hasMoreSubtopics = filteredTopics?.some(
	// 	(topic) => topic.SUBTOPICS?.length > (currentPage + 1) * subtopicsPerPage
	// );

	const handleNextPage = () => {
		setCurrentPage((prev) => prev + 1);
	};

	const handlePreviousPage = () => {
		setCurrentPage((prev) => (prev > 0 ? prev - 1 : 0));
	};

	// Update search input handler
	const handleSearch = (e) => {
		setSearchQuery(e.target.value);
		setCurrentPage(0); // Reset to first page when searching
	};

	//setting the selected subtopic data in redux
	// const handleSubTopicClickInternal = async (topicId, subtopicId) => {
	// 	await fetchDataForTopicSubtopicNames(topicId, subtopicId);
	// 	let identifier =
	// 		topicId === '' && subtopicId === '' ? 'USER_SPECIFIC' : 'TOPIC_SUBTOPIC_SPECIFIC';

	// 	await fetchAndSetNoteBookList(identifier, topicId, subtopicId);

	// 	handleSubTopicClick(); // Existing handler
	// };

	// const fetchDataForTopicSubtopicNames = async (topicId, subtopicId) => {
	// 	let topicName = '';
	// 	let subtopicName = '';
	// 	let subjectName = '';
	// 	const res = await fetchTopicSubtopicNames(topicId, subtopicId);
	// 	logger.log('Result for topicname:', res);
	// 	topicName = res.data.data.topicName;
	// 	subtopicName = res.data.data.subtopicName;
	// 	subjectName = res?.data?.data?.subjectName;
	// 	logger.log('Subject name inside handleSubTopicClickInternal; ', subjectName);
	// 	dispatch(
	// 		setSelectedSubTopicData({
	// 			topicId,
	// 			subtopicId,
	// 			notebookId: null,
	// 			topicName,
	// 			subtopicName,
	// 			subjectName,
	// 		})
	// 	);
	// };

	// const fetchAndSetNoteBookList = async (identifier, topicId, subtopicId) => {
	// 	// let userId = "1049";
	// 	setIsLoading(true);
	// 	try {
	// 		const response = await fetchNoteBookList(userId, identifier, topicId, subtopicId);
	// 		let responseData = response.data?.noteBookList;
	// 		logger.log('Notebook list data: ', responseData);
	// 		if (responseData.length != 0) {
	// 			responseData = responseData.sort(
	// 				(a, b) => new Date(b.UPDATED_AT) - new Date(a.UPDATED_AT)
	// 			);
	// 			logger.log('Printing Sorted Notebook List: ', responseData);
	// 		}
	// 		dispatch(setNotebookList(responseData));
	// 	} catch (error) {
	// 		logger.log('Error fetching notebook list:', error);
	// 	} finally {
	// 		setIsLoading(false);
	// 	}
	// };

	return (
		<div className="learning-map">
			{/* Update search input */}
			{isLoading ? (
				<Loader />
			) : (
				<React.Fragment>
					{alert?.status && (
						<Box
							sx={{
								display: 'flex',
								width: '100%',
								justifyContent: 'flex-end',
								paddingRight: { xs: '0', sm: '3.81rem' },
							}}
						>
							<Alert
								variant="filled"
								severity={alert?.severity}
								sx={{ width: 'fit-content' }}
							>
								{alert?.msg}
							</Alert>
						</Box>
					)}
					<Box
						sx={{
							display: 'flex',
							flexDirection: { xs: 'column', sm: 'row' },
							alignItems: { xs: 'start', sm: 'center' },
							justifyContent: 'space-between',
							marginBottom: '2rem',
							paddingRight: { xs: '0', sm: '3.81rem' },
							width: '100%',
						}}
					>
						<Label
							label="The Learning Map"
							fontSize="27px"
							fontWeight="700"
							color="black"
							// style={{ width: 'fit-content' }}
						/>
						<Box
							sx={{
								display: 'flex',
								// alignSelf: "end",
								// alignItems: "end",
								flexDirection: 'row',
								justifyContent: { xs: 'space-between', sm: 'end' },
								width: '100%',
							}}
						>
							<Paper
								component="form"
								sx={{
									p: '0px 4px',
									display: 'flex',
									alignItems: 'center',
									width: { xs: '10rem', sm: '15rem' },
									marginTop: {
										xs: '2rem',
										sm: '0rem',
									},
									marginRight: {
										xs: 0,
										sm: '3.8rem',
									},
									borderColor: '#000',
									border: 1,
									borderRadius: '15px',
								}}
							>
								<InputBase
									sx={{ ml: 1, flex: 1 }}
									placeholder="Search"
									inputProps={{ 'aria-label': 'Search Topic or Sub Topic' }}
									onChange={handleSearch}
								/>
								<IconButton type="button" sx={{ p: '10px' }} aria-label="search">
									<SearchIcon />
								</IconButton>
							</Paper>
							<Box sx={{ display: { xs: 'flex', sm: 'none' } }}>
								<Button
									variant="contained"
									onClick={() => setSidebarState(true)}
									sx={{
										backgroundColor: '#000',
										marginTop: {
											xs: '2rem',
											sm: '0rem',
										},
									}}
								>
									Notebook
								</Button>
							</Box>
						</Box>
					</Box>
					<Box
						sx={{
							marginTop: '1rem',
							display: 'flex',
							flexDirection: 'row',
							gap: '20px',
							height: {
								xs: 'calc(100vh - 345px)',
								sm: 'calc(100vh - 192.8px - 128px)',
							},
							overflowY: 'auto',
							whiteSpace: 'nowrap',
							scrollbarWidth: 'none',
							position: 'relative',
							overflowX: { xs: 'hidden', sm: '' },
							width: '100%',
						}}
					>
						{topics?.length === 0 ? (
							<div className="no-data-message">
								<Label
									label="No topics available for the selected tab."
									fontSize="20px"
									fontWeight="500"
									color="gray"
								/>
							</div>
						) : (
							<Box
								className="learning-map-content"
								sx={{
									display: 'flex',
									flexDirection: 'row',
									gap: '20px',
									height: 'fit-content',
									width: '100%',
									padding: '0.5rem',
								}}
							>
								{/* <div className='pagination-buttons'>
						{currentPage > 0 && (
							<button
								className='pagination-button prev-button'
								onClick={handlePreviousPage}>
								&#8250;
							</button>
						)}
						{hasMoreSubtopics && (
							<button
								className='pagination-button next-button'
								onClick={handleNextPage}>
								&#8250;
							</button>
						)}
					</div> */}

								<Box
									// className='topic-wrapper'
									sx={{
										display: 'flex',
										flexDirection: 'column',
										gap: '1.25rem',
										width: '100%',
									}}
								>
									{paginatedTopics?.map((topic, topicIndex) => (
										<Box
											key={topicIndex}
											className="topic-row"
											sx={{
												// flexWrap: { xs: "wrap", sm: "nowrap" },
												flexDirection: { xs: 'column', sm: 'row' },
												justifyContent: { xs: 'center', sm: 'start' },
												alignItems: 'start',
												marginBottom: { xs: '1.5rem', sm: '0rem' },
											}}
										>
											<TopicCard
												progress={topic.TOPIC_PROGRESS}
												title={topic.TOPIC_NAME}
												color={topic.TOPIC_PROGRESS_COLOR}
											/>
											{/* <div className='subtopic-wrapper'>
									{topic.displayedSubtopics?.map((subtopic, j) => (
										<SubTopicCard
											key={`${i}-${j}`}
											progress={subtopic.PROGRESS}
											title={subtopic.SUBTOPIC_NAME}
											handleSubTopicClick={() =>
												handleSubTopicClickInternal(
													topic.TOPIC_ID,
													subtopic.SUBTOPIC_ID
												)
											}
										/>
									))}
								</div> */}
											<Box
												sx={{
													display: 'flex',
													flexDirection: 'row',
													// width: "calc(100vw - 2rem)",
												}}
											>
												<Box
													className="test-pagination-buttons"
													sx={{ display: { xs: 'none', sm: 'flex' } }}
												>
													{
														<IconButton
															sx={{
																'&:hover': {
																	backgroundColor: 'transparent',
																},
															}}
															onClick={() =>
																scrollHorizontally(topicIndex, -200)
															}
														>
															<KeyboardArrowLeftIcon
																fontSize="large"
																sx={{
																	color: 'black',
																}}
															/>
														</IconButton>
													}
												</Box>
												<Box
													ref={subtopicRef}
													sx={{
														overflow: 'hidden',
														maxWidth: {
															xs: 'calc(100vw - 2rem)',
															sm: subtopicWidth
																? `${subtopicWidth}rem`
																: 'auto',
														},
														width: {
															xs: 'calc(100vw - 2rem)',
															sm: subtopicWidth
																? `${subtopicWidth}rem`
																: 'auto',
														},
													}}
												>
													<Box
														ref={(el) =>
															(scrollRefs.current[topicIndex] = el)
														} // Store the reference for this row
														sx={{
															display: 'flex',
															flexDirection: 'column',
															gap: '20px',
															width: '100%', // Changed to 90% of viewport width
															overflowX: 'auto',
															whiteSpace: 'nowrap',
															scrollbarWidth: 'none', // Hides scrollbar (Firefox)
															'&::-webkit-scrollbar': {
																display: 'none',
															}, // Hides scrollbar (Chrome, Safari)
														}}
													>
														<Box
															sx={{ display: 'flex', gap: '1.25rem' }}
														>
															{topic.displayedSubtopics?.map(
																(subTopic, subTopicIndex) => (
																	<SubTopicCard
																		key={`${topicIndex}-${subTopicIndex}`}
																		streak={subTopic.streak}
																		lastStudied={subTopic.lastStudied}
																		progress={
																			subTopic.SUBTOPIC_PROGRESS
																		}
																		title={
																			subTopic.SUBTOPIC_NAME
																		}
																		handleSubTopicClick={() =>
																			handleSubTopicClickInternal(
																				topic.TOPIC_ID,
																				subTopic.SUBTOPIC_ID,
																				setIsLoading
																			)
																		}
																		topicId={topic.TOPIC_ID}
																		subtopicId={
																			subTopic.SUBTOPIC_ID
																		}
																		section={selectedMainTab}
																		subtopicList={
																			cardSubtopics[
																				selectedMainTab
																			]
																		}
																		setCardSubtopics={
																			setCardSubtopics
																		}
																		setAlert={setAlert}
																		alertTimeoutRef={
																			alertTimeoutRef
																		}
																		color={
																			subTopic.SUBTOPIC_PROGRESS_COLOR
																		}
																	/>
																)
															)}
														</Box>
													</Box>
												</Box>
												<Box
													className="test-pagination-buttons"
													sx={{ display: { xs: 'none', sm: 'flex' } }}
												>
													{
														<IconButton
															aria-label="next"
															sx={{
																'&:hover': {
																	backgroundColor: 'transparent',
																},
															}}
															onClick={() =>
																scrollHorizontally(topicIndex, 200)
															}
														>
															<KeyboardArrowRightIcon
																fontSize="large"
																sx={{
																	color: 'black',
																}}
															/>
														</IconButton>
													}
												</Box>
											</Box>
										</Box>
									))}
								</Box>
							</Box>
						)}
					</Box>
				</React.Fragment>
			)}
		</div>
	);
};

export default LearningMap;
